import { Globe, Instagram } from "lucide-react";

export const Footer = () => (
  <footer data-testid="app-footer" className="relative z-[2] bg-stone-950 text-stone-300 border-t border-amber-900/30 py-8 px-6 pb-28">
    <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
      <div>
        <p className="font-display font-bold text-amber-50">Teatro Torpignattara</p>
        <p className="text-xs text-stone-500 mt-1">© {new Date().getFullYear()} Copyright Teatro Torpignattara</p>
      </div>
      <div className="flex flex-wrap gap-3">
        <a
          data-testid="footer-website-link"
          href="https://www.teatrotorpignattara.it"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 rounded-full border border-stone-700 px-4 py-2 text-sm hover:border-amber-500 hover:text-amber-300 transition-colors"
        >
          <Globe className="h-4 w-4" /> www.teatrotorpignattara.it
        </a>
        <a
          data-testid="footer-instagram-link"
          href="https://www.instagram.com/teatrotorpignattara"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 rounded-full border border-stone-700 px-4 py-2 text-sm hover:border-[#E0533C] hover:text-[#F08A78] transition-colors"
        >
          <Instagram className="h-4 w-4" /> @teatrotorpignattara
        </a>
      </div>
    </div>
  </footer>
);
